import _ from 'lodash'

/** Pretty straightfoward JavaScript conversion of the BibTeX file.
 * Converted by `bibtex-loader.js`. */
export const papers = require('../../content/ertl.utf8.bib')

/** Pretty straightfoward JavaScript conversion of the BibTeX file.
 * Converted by `bibtex-loader.js`. */
export const awards = require('../../content/award.utf8.bib')

const monthNameToNumber = {
    Jan: 1, Feb: 2, Mar: 3, Apr: 4,
    May: 5, Jun: 6, Jul: 7, Aug: 8,
    Sep: 9, Oct: 10, Nov: 11, Dec: 12,
}

const myTypeSortOrder = {
    journal: 1,
    iconference: 2,
    dconference: 3,
    poster: 4,
    book: 5,
    tutorial: 6,
}

/**
 * @param entry {BibEntry}
 * @return {[number, number]}
 */
function bibEntryToDate(entry) {
    const year = parseInt(entry.year, 10)
    const month = monthNameToNumber[entry.month] || parseInt(entry.month, 10)
    if (!isFinite(year) || !month || !isFinite(month)) {
        throw new Error(`Can't figure out the year of the BibTeX entry: ${JSON.stringify(entry)}`)
    }
    return [year, month]
}

function bibEntryToType(entry) {
    return (entry.memo && entry.memo.split('-')[1]) || ''
}

function bibEntryToDateNum(entry) {
    const [year, month] = bibEntryToDate(entry)
    return year * 12 + month
}

/**
 * @param entry {BibEntry}
 * @return {number}
 */
export function bibEntryToFinancialYear(entry) {
    const [year, month] = bibEntryToDate(entry)
    return month < 4 ? year - 1 : year
}

/**
 * @param entries {BibEntry[]}
 * @return {[number, [BibType, BibEntry[]][]][]}
 */
export function groupBibEntries(entries) {
    // Augument the entries
    entries = entries.map(entry => ({
        ...entry,
        financialYear: bibEntryToFinancialYear(entry),
        dateNum: bibEntryToDateNum(entry),
        yearMonth: bibEntryToDate(entry),
        myType: bibEntryToType(entry),
    }))

    // Sort entries in the reverse chronological order
    entries.sort((a, b) => b.dateNum - a.dateNum)

    // Group by years
    let groups = _.toPairs(_.groupBy(entries, 'financialYear'))
    groups.sort((a, b) => b[0] - a[0])

    // Group by types
    groups = groups.map(([year, entries]) =>
        [
            year,
            _.toPairs(_.groupBy(entries, 'myType'))
                .sort((a, b) => myTypeSortOrder[a[0]] - myTypeSortOrder[b[0]]),
        ])

    return groups
}